import Vue from 'vue';
import VueResource from 'vue-resource';
import moment from 'moment';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

export default {
  listaPendentes: (mostrarPrestacao = 0, filtros = {}) => {
    const params = { mostrarPrestacao };

    if (filtros.idProjeto && filtros.idProjeto !== '0') {
      params.idProjeto = filtros.idProjeto;
    }

    if (filtros.documento) {
      params.documento = filtros.documento;
    }

    if (filtros.periodo && filtros.periodo[0] && filtros.periodo[1]) {
      params.dataInicio = moment(filtros.periodo[0]).format('MM/DD/YYYY');
      params.dataFim = moment(filtros.periodo[1]).format('MM/DD/YYYY');
    }

    return Vue.http.get('/api/solicitacaoreembolsos/atividades', { params });
  },
  arquivos: id => {
    return Vue.http.get(`/api/solicitacaoreembolsos/cript/${id}/arquivos`)
      .then(response => response.data);
  },
  download: (id, arquivo) => {
    return Vue.http.get(`/api/solicitacaoreembolsos/cript/${id}/downloadarquivo/${encodeURIComponent(arquivo)}`, {
      responseType: 'blob'
    })
    .then(response => salvarArquivo(response, arquivo))
    .then(salvo => salvo.download());
  },
  obterPorId: id => {
    return Vue.http.get(`/api/solicitacaoreembolsos/cript/${id}`)
      .then(response => response.data);
  },
  prestacao: id => {
    return Vue.http.get(`/api/solicitacaoreembolsos/cript/${id}/prestacao`)
      .then(response => response.data);
  },
  salvarAtividade: (id, formData) => {
    return Vue.http.post(`/api/solicitacaoreembolsos/cript/${id}/Atividade`, formData);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-reembolso-atividade/servico.js